import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const ApplicationRequirements = () => {
  const { t } = useTranslation();

  // List for the format
  const formatList = [
    <>{t('scholarships.openCallFormatList1')} <a href="/scholarship-application.pdf" download className="text-blue-700 underline hover:text-blue-900 ml-1">{t('scholarships.openCallDownload')}</a></>,
    t('scholarships.openCallFormatList2'),
    t('scholarships.openCallFormatList3'),
    t('scholarships.openCallFormatList4'),
    t('scholarships.openCallFormatList5'),
    t('scholarships.openCallFormatList6'),
    t('scholarships.openCallFormatList7'),
    t('scholarships.openCallFormatList8'),
    t('scholarships.openCallFormatList9')
  ];

  return (
    <>
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="mb-8"
    >
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        {t('scholarships.requirementsTitle')}
      </h2>
      
      

      <div className="bg-white rounded-lg shadow-md p-6">
        
        <ul className="list-disc pl-5 space-y-2 text-gray-600 mb-6">
          {formatList.map((item, i) => (
            <motion.li 
              key={item}
              whileHover={{ x: 5 }}
            >
              <li key={i}>{item}</li>
          
            </motion.li>
          ))}
        </ul>
        
        
      </div>
    </motion.div>

    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="mb-8"
    >
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        {t('scholarships.eligibilityTitle')}
      </h2>
      
      

      <div className="bg-white rounded-lg shadow-md p-6">
        
        
        <ul className="list-disc pl-5 space-y-2 text-gray-600">
          {[1, 2, 3, 4].map(item => (
            <motion.li 
              key={item}
              whileHover={{ x: 5 }}
            >
              {t(`scholarships.eligibilityItem${item}`)}
            </motion.li>
          ))}
        </ul>
      </div>
    </motion.div>
  </>);
};

export default ApplicationRequirements;
